import actions from '../../actionTypes';

export default workflows => {
  return {
    type: actions.SET_WORKFLOWS,
    workflows
  };
};



// WEBPACK FOOTER //
// ./src/reducers/workflows/actions/setWorkflows.js